<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Transaction History</h2>
      </div>

      <div class="row">
        <el-input
          style="max-width: 200px"
          placeholder="Customer Name"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <el-date-picker
          v-model="period"
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          style="width: 500px"
        ></el-date-picker>
      </div>

      <div class="main-container transaction-table-height">
        <vue-good-table
          :lineNumbers="true"
          :columns="fields"
          :rows="transactionHistories"
          :search-options="{
            enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm
          }"
          :pagination-options="{
            enabled: true
          }"
        >
          <template slot="table-row" slot-scope="props" style="background: red">
            <span v-if="props.column.field == 'transactionReference'">
              {{
                props.row.transactionReference
                  ? props.row.transactionReference
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'fullName'">
              <span v-if="props.row.user">
                {{
                  props.row.user.fullname !== null
                    ? props.row.user.fullname
                    : "----"
                }}
              </span>
              <span v-else>_____</span>
            </span>
            <span v-if="props.column.field == 'amountPaid'">
              {{
                props.row.actualAmount
                  ? `NGN ${props.row.actualAmount
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                  : "----"
              }}
            </span>

            <span
              v-if="props.column.field == 'paymentStatus'"
              class="center-svg"
            >
              <span v-if="props.row.status">
                {{
                  props.row.status == "success"
                    ? `Success - **** **** **** ${(props.row.detail &&
                        props.row.detail.card &&
                        props.row.detail.card.last_4digits) ||
                        ""} (${(
                        (props.row.detail &&
                          props.row.detail.card &&
                          props.row.detail.card.type) ||
                        " "
                      )
                        .toString()
                        .charAt(0)
                        .toUpperCase() +
                        (
                          (props.row.detail &&
                            props.row.detail.card &&
                            props.row.detail.card.type) ||
                          " N/A"
                        )
                          .toString()
                          .substr(1)
                          .toLowerCase()})`
                    : "Failed transaction"
                }}
                <!-- {{props.row.status ? props.row.status : "----"}} -->
              </span>

              <span v-else>----</span>
            </span>

            <span v-if="props.column.field == 'transactionType'">
              {{
                props.row.transactionType ? props.row.transactionType : "----"
              }}
            </span>

            <span v-if="props.column.field == 'paymentTime'">
              <span v-if="props.row.createdAt">
                {{ formatDate(props.row.createdAt) }}
                {{ formatTime(props.row.createdAt) }}
              </span>
              <span v-else>----</span>
            </span>

            <span v-if="props.column.field == 'message'">
              <span v-if="props.row.detail">
                {{
                  props.row.detail.message ||
                    props.row.detail.processor_response ||
                    "----"
                }}
              </span>
              <span v-else>----</span>
            </span>

            <span v-if="props.column.field == 'email'">
              <span v-if="props.row.user">
                {{
                  props.row.user.email !== null ? props.row.user.email : "----"
                }}
              </span>
              <span v-else>_____</span>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { mapGetters } from "vuex";
import transaction_historyVue from "../payment/transaction_history.vue";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

export default {
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      period: "",
      fields: [
        {
          field: "transactionReference",
          label: "Transaction Ref",
          sortable: "true"
        },
        {
          field: "fullName",
          label: "Name",
          sortable: "true"
        },
        {
          field: "amountPaid",
          label: "Amount",
          sortable: "true"
        },
        {
          field: "paymentStatus",
          label: "Transaction Status",
          sortable: "true"
        },
        {
          field: "transactionType",
          label: "Transaction Type",
          sortable: "true"
        },
        {
          field: "paymentTime",
          label: "Date & Time",
          sortable: "true"
        },
        {
          field: "message",
          label: "Reason",
          sortable: "false"
        },
        {
          field: "email",
          label: "Email",
          sortable: "false"
        }
      ],
      transactionHistories: [],
      serverParams: {
        perPage: 10,
        page: 1
      }
    };
  },
  computed: {
    ...mapGetters(["transactionHistories"])
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMMM, YYYY");
    },
    formatTime(date) {
      return moment(date).format("hh:mm a");
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.init();
    },
    searchTable(row, col, cellValue, searchTerm) {
      const term = searchTerm.toLowerCase();

      let startDate = this.period[0] !== undefined ? this.period[0] : false;
      let endDate = this.period[1] !== undefined ? this.period[1] : false;

      const transCheck = row.transactionReference.indexOf(term) > -1;
      const userCheck =
        row.detail &&
        row.detail.customer &&
        row.detail.customer.name &&
        row.detail.customer.name.toLowerCase().indexOf(term) > -1;
      const dateCheck =
        startDate == false
          ? true
          : moment(row.createdAt).isBetween(startDate, endDate, "days")
          ? true
          : false;

      if ((transCheck || userCheck) && dateCheck) {
        return true;
      }
      return false;
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.init();
    },
    init() {
      const httpUtils = this.$httpUtils.FINANCE_HTTP;
      // let url = `/transactionHistories`;
      let url = `transactions`;

      httpUtils
        .get(url)
        .then(response => {
          this.transactionHistories = response.data.data || [];
        })
        .catch(error => {
          console.log("transactionUrl error", error);
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    await this.init();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

.center-svg {
  display: flex;
  margin: 0px auto;
}

table th,
table th span {
  font-size: 0.7em;
}
.row {
  margin-bottom: 32px;
}
.transaction-table-height {
  height: calc(100vh - 320px) !important;
}
.transaction-table-height table.vgt-table {
  margin: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/adminBilling/AdminTransactionHistory.vue